export default __webpack_public_path__ + "static/media/eye-roll-acoaster.b1e4d94d.gif";